import { DtNumber } from '@ow/ditto-core'

const { validation, transformer, filterSpec } = DtNumber
export { default as Render } from './render'
// export { default as validation } from './validation'
export { default as Filter } from './filter'
// export { filterSpec, config } from './config'
// export { default as transformer } from './transformer'
export { validation, transformer, filterSpec }
